(() => {
  const init = () => {
    const header = document.querySelector('store-header');
    if (!header || header.dataset.gmOverlaysReady) return;
    header.dataset.gmOverlaysReady = 'true';
    const menu = header.querySelector('.gm-menu-dialog');
    const toggle = header.querySelector('.main-menu__toggle');
    toggle?.addEventListener('click', (event) => {
      if (matchMedia('(min-width:769px)').matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      menu.showModal();
      document.body.classList.add('gm-overlay-open');
      menu.querySelector('button').focus();
    }, true);
    header.querySelectorAll('dialog.gm-overlay').forEach((dialog) => {
      let closeTimer;
      const finishClose = () => {
        clearTimeout(closeTimer);
        dialog.classList.remove('gm-is-closing');
        dialog.close();
      };
      const close = () => {
        if (!dialog.open || dialog.classList.contains('gm-is-closing')) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finishClose();
          return;
        }
        dialog.classList.add('gm-is-closing');
        closeTimer = setTimeout(finishClose, 260);
      };
      dialog.addEventListener('animationend', (event) => {
        if (event.target === dialog && ['gm-overlay-out', 'gm-menu-out'].includes(event.animationName)) finishClose();
      });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          close();
        }
      }, true);
      dialog.addEventListener('click', (event) => {
        if (!event.target.closest('.gm-search-close, .gm-overlay-close')) return;
        event.preventDefault();
        event.stopPropagation();
        close();
      }, true);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      });
      dialog.addEventListener('close', () => {
        clearTimeout(closeTimer);
        dialog.classList.remove('gm-is-closing');
        dialog.querySelector('predictive-search')?.close();
        document.body.classList.remove('gm-overlay-open');
      });
    });
    matchMedia('(min-width:769px)').addEventListener('change', (event) => {
      if (event.matches && menu?.open) menu.close();
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
